<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="part" id="_idParaDest-8">The Trong Troupe</h1>
<p class="center">Trong Impresario</p>
<p class="center"> </p>
<p class="center">Ambria Impresario, Trong’s second wife</p>
<p class="center"> </p>
<p class="center">K’linpor Actor, Trong’s son</p>
<p class="center"> </p>
<p class="center">Halma Actor, K’linpor’s wife</p>
<p class="center"> </p>
<p class="center">Uthiam Piper, Ambria’s daughter</p>
<p class="center"> </p>
<p class="center">Golfren Piper, Uthiam’s husband</p>
<p class="center"> </p>
<p class="center">Yama Actor, Ambria’s cousin</p>
<p class="center"> </p>
<p class="center">Dolm Actor, Yama’s husband</p>
<p class="center"> </p>
<p class="center">Piol Poet, brother of Ambria’s first husband</p>
<p class="center"> </p>
<p class="center">Gartol Costumer, Trong’s cousin</p>
<p class="center"> </p>
<p class="center">Olimmiar Dancer, Halma’s sister</p>
<p class="center"> </p>
<p class="center">Klip Trumpeter, Gartol’s stepbrother</p>
<p class="center"> </p>
<p class="center">Eleal Singer, an orphan</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// PastImperative7.vue?65405308